module.exports = __webpack_public_path__ + "img/stock5.91b3f5b6.png";